module.exports = __webpack_public_path__ + "static/media/poultryup_home.a55b5859.jpg";